import { BrandLogo } from '@common/components/brand-logo';
import { Link } from '@konova/ui/link';
import { Stack } from '@konova/ui/stack';
import { Typography } from '@konova/ui/typography';
import clsx from 'clsx';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './legal-footer.module.scss';

export type LegalFooterProps = {
  /**
   * Function called when the "Show Imprint" button is clicked.
   * This function doesn't take any arguments and doesn't return any value.
   */
  onShowImprintClicked?: () => void;

  /**
   * Represents the name of the environment.
   */
  envName?: string;
};

export const LegalFooter: FC<LegalFooterProps> = ({ onShowImprintClicked, envName }) => {
  const [t] = useTranslation();

  return (
    <Stack
      align="spread"
      crossAxis="center"
      className={clsx('legal-footer footer-about', classes.root)}
    >
      <Stack
        crossAxis="center"
        className={clsx('legal-footer__imprint footer-imprint')}
      >
        <BrandLogo size="small" />
        <Typography variant="meta">|</Typography>
        <Link
          as="button"
          variant="meta"
          color="primary"
          onClick={onShowImprintClicked}
          data-testid="imprint-toggle"
        >
          {t('components.footer.imprint.title')}
        </Link>
      </Stack>

      {envName && (
        <Typography
          variant="caption"
          color="grey.dark"
          className="legal-footer__env footer-env"
        >
          {envName}
          {' '}
          <span className={classes.version} data-testid="app-version">
            {import.meta.env.VITE_APP_VERSION}
          </span>
        </Typography>
      )}
    </Stack>
  );
};
